<template>
  <div class="pc-preview-container">
    <img
      alt="phone-empty"
      src="@shared/assets/img/partner-detail/my-tech.png"
      class="pc-phone-img"
    />
  </div>
</template>

<script>
export default {
  name: 'MyTechPreview',
};
</script>

<style lang="scss" scoped>
.pc-preview-container {
  margin-left: 24px;

  .pc-preview-background {
    position: relative;
    border-radius: 50px;
    background-color: $N100;
    height: 91%;
  }

  .pc-phone-img {
    height: 530px;
  }

  .pc-phone-item {
    height: 50px;
    padding: 10px;
  }

  .pc-absolute-overlay {
    position: absolute;
    left: 15px;
    right: 15px;
    top: 80px;
    height: 400px;
    padding: 6px;

    .pc-bubble {
      background-color: #2b3757;
      width: 100%;
      height: 48px;
      border-radius: 4px;

      &:not(:first-child) {
        margin-top: 4px;
      }

      .pc-phone-container {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        padding-top: 8px;

        .pc-phone-title {
          font-size: 12px;
          font-weight: bold;
          color: white;
        }

        .pc-phone-subtitle {
          font-size: 8px;
          color: white;
        }
      }
    }
  }

  .pc-preview-title {
    margin-top: 14px;
    text-align: center;
  }
}
</style>
